export default __webpack_public_path__ + "./images/sx.19a47e1a.png";